var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.575C11.8667 21.575 11.7417 21.554 11.625 21.512C11.5083 21.4707 11.4 21.4 11.3 21.3L5.7 15.7C5.51667 15.5167 5.425 15.2873 5.425 15.012C5.425 14.7373 5.51667 14.5 5.7 14.3C5.9 14.1 6.13734 14 6.412 14C6.68734 14 6.925 14.1 7.125 14.3L11 18.175V3C11 2.71667 11.096 2.479 11.288 2.287C11.4793 2.09567 11.7167 2 12 2C12.2833 2 12.521 2.09567 12.713 2.287C12.9043 2.479 13 2.71667 13 3V18.175L16.9 14.3C17.0833 14.1167 17.3123 14.0207 17.587 14.012C17.8623 14.004 18.1 14.1 18.3 14.3C18.4833 14.4833 18.575 14.7167 18.575 15C18.575 15.2833 18.4833 15.5167 18.3 15.7L12.7 21.3C12.6 21.4 12.4917 21.4707 12.375 21.512C12.2583 21.554 12.1333 21.575 12 21.575Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouth);
export default __webpack_public_path__ + "static/media/south.5dfcf3293604dee57557731a2bc55755.svg";
export { ForwardRef as ReactComponent };